import { u as i } from "../styled-components.browser.esm-3eb04950.js";
const h = i.div`
  width: 40%;
  height: 100%;
  @media (max-width: 1600px) {
    width: 100%;
    min-height: 40%;
    max-height: 40%;
  }
`;
export {
  h as InformationsContainer
};
//# sourceMappingURL=InformationsContainer.js.map
